import { PublicKeyRepository } from '@/Domain/XmlOffer/Encrypter/PublicKeyRepository'
import { PublicKeyRepositoryError, PublicKey } from '@/Domain/XmlOffer/Encrypter'
import { Province } from '@/Domain/Procedures'
import { ApiClient } from '@/Domain/ApiClient'

interface PublicKeyResponse {
  employeeId: number;
  keyValue: string;
}

export class AxiosPublicKeyRepository implements PublicKeyRepository {
  private _apiClient: ApiClient

  constructor (apiClient: ApiClient) {
    this._apiClient = apiClient
  }

  async byProvince (province: Province): Promise<PublicKey[]> {
    const url = '/sobree/api/publicKey/' + province
    try {
      const response = await this._apiClient.makeGetRequest(url, {})
      return response.data.data.map((current: PublicKeyResponse) => {
        return new PublicKey(current.employeeId, current.keyValue)
      })
    } catch (error) {
      return Promise.reject(new PublicKeyRepositoryError(error.message))
    }
  }
}
